module.exports = __webpack_public_path__ + "static/img/London-Tavern.a5b2d34.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/London-Tavern.jpg
// module id = iO5m
// module chunks = 0